/**
 * JWT 의 sub(로그인 계정 아이디)를 읽는다 — 서명은 확인하지 않는다(서버가 쿠키로 매 요청 검증한다).
 * 화면의 사용자별 키(버전 알림 "이미 봤음")에만 쓰고 권한 판단에는 쓰지 않는다. 형식이 아니면 null.
 */
export function jwtSubject(token: string | null | undefined): string | null {
  if (!token) return null;
  const part = token.split('.')[1];
  if (!part) return null;
  try {
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '=');
    const json = decodeURIComponent(
      Array.from(atob(b64), (c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
    );
    const sub = (JSON.parse(json) as { sub?: unknown }).sub;
    return typeof sub === 'string' && sub.length > 0 ? sub : null;
  } catch {
    return null;
  }
}
